/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IObrienSlideParallaxData } from './obrien-slide-parallax.data';
import { IObrienSlideParallaxProps } from './obrien-slide-parallax.props.autogenerated';

import LinksComponent1 from './components/links1';

export interface IObrienSlideParallaxViewProps extends IObrienSlideParallaxProps<IObrienSlideParallaxData> {
    obHeroTitle: React.ReactNode;
    obHeroImage: React.ReactNode;
    obHeroImageOverlay: React.ReactNode;
    obHeroId: string;
    obHeroContent: string;
    obHeroButtonLink: string;
    obHeroButtonText: string;
    imageContainer: INodeProps;
    links1?: React.ReactNode;

}

/**
 *
 * ObrienHomeHero component
 * @extends {React.PureComponent<IObrienSlideParallaxProps<IObrienSlideParallaxData>>}
 */
class ObrienSlideParallax extends React.PureComponent<IObrienSlideParallaxProps<IObrienSlideParallaxData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const { obHeroImage, obHeroImageOverlay, obHeroTitle, links1 } = this.props.config;

        //const HeroTitle = config.obHeroTitle ? config.obHeroTitle : 'No Header Name Provided';

        const HeroTitle = obHeroTitle && (
            <Msdyn365.Text
              tag={obHeroTitle.tag || 'h2'}
              text={obHeroTitle.text}
              className='ob-hero-title'
              editProps={{onEdit: this.handleTextChange1, requestContext:this.props.context.request}}
            />
        );

        const imageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obHeroImage && obHeroImage.imageSettings,
        };

        const heroImage = obHeroImage && (
            <Msdyn365.Image {...obHeroImage} {...imageProps} editProps ={{key:this.props.config.obHeroImage || {}, requestContext: this.props.context.request}}/>
        );

        const imageOverlayProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obHeroImageOverlay && obHeroImageOverlay.imageSettings,
        };

        const heroImageOverlay = obHeroImageOverlay && (
            <Msdyn365.Image {...obHeroImageOverlay} {...imageOverlayProps} editProps ={{key:this.props.config.obHeroImageOverlay || {}, requestContext: this.props.context.request}}/>
        );

        const contentBlockLinks1 = links1 && links1.length > 0 && <LinksComponent1 {...{ links1 }} />;

        //const HeroImage = config.obHeroImage ? config.obHeroImage.src : '';
        const HeroId = config.obHeroId ? config.obHeroId : 'noclass';
        const HeroContent = config.obHeroContent ? config.obHeroContent : '';
        const HeroButtonLink = config.obHeroButtonLink ? config.obHeroButtonLink : '#';
        const HeroButtonText = config.obHeroButtonText ? config.obHeroButtonText : 'No Text';
        const ObrienHomeHeroProps = {
            ...this.props,
            obHeroTitle: HeroTitle,
            obHeroImage: heroImage,
            obHeroImageOverlay: heroImageOverlay,
            obHeroId: HeroId,
            obHeroContent: HeroContent,
            obHeroButtonLink: HeroButtonLink,
            obHeroButtonText: HeroButtonText,
            imageContainer: {},
            links1: contentBlockLinks1
        };

        return this.props.renderView(ObrienHomeHeroProps);
    }
    public handleTextChange1 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obHeroTitle!.text = event.target.value;
}

export default ObrienSlideParallax;
